import styled from 'styled-components';

import { baseSelectItem, textSizes } from 'utils/style';
import AddressItem from 'components/form/AddressSelector/Items/Address/container';

export default styled(AddressItem)`
  ${baseSelectItem};

  &:disabled {
    cursor: pointer;
    &:hover {
      background: inherit;
    }
  }

  .address {
    color: var(--grey900);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .subaddress {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: ${textSizes('M')};
    color: var(--grey700);
  }
`;
